import {type LoaderFunctionArgs, type MetaFunction} from 'react-router'
import {useSearchParams} from 'react-router'
import {routerPaths} from '@routes'
import {assertAnonymousAtLogin} from '@core/auth/auth.server'
import {mergeMeta} from '@core/lib/mergeMeta'
import {SignInCard} from '@core/auth-ui/SignInCard/SignInCard'
import {TOILE_SIGN_IN_CARD} from '@product/toile/wall/signInCard'
import styles from '@product/toile/styles/Auth/auth-login.module.scss'

export const meta: MetaFunction = ({matches}) => {
    return mergeMeta(matches, [
        {name: 'robots', content: 'noindex, nofollow'},
    ])
}

export async function loader({request}: LoaderFunctionArgs) {
    // Already signed in: on to where this sign-in would have landed, before the card renders.
    await assertAnonymousAtLogin(request)

    // The magic-link nonce (read by SignInCard) is minted once in the shared root loader
    // (app/root.tsx) and reused by every mount site — see its comment for why. Nothing to do here.
    return null
}

export default function Login() {
    const [searchParams] = useSearchParams()
    const authError = searchParams.get('auth-error')

    return (
        <div className={styles.page}>
            {/* No page header: the card carries the lockup itself (SignIn.dc.html) */}
            <main className={styles.main}>
                <SignInCard
                    {...TOILE_SIGN_IN_CARD}
                    googleAuthAction={routerPaths['/auth/:provider']({provider: 'google'})}
                    authError={authError}
                />
            </main>
        </div>
    )
}
